<template>
    <div class="bazis-club-category-items" v-if="counter != null">
        <div class="category-item" v-for="item in pageSetup.bazis_club_category">
            <router-link :to="{ name : 'bazis-club-card', params:{id : item.category.slug , title : item.category_desc}}" @click.native="startLoader" class="category-link">
                <div class="caregory-icon">
                    <img :src="item.category_icon" alt="">
                </div>
                <!-- <div class="category-count">
                    <p><span>{{counter[item.category.slug]}}</span>{{pageSetup.syntax.partners_count}}</p>
                </div> -->
                <div class="category-desc">
                    <h3>{{item.category_desc}}</h3>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'bazis-club-category',
        components: {
        },
        data () {
            return {
                counterArr: [],
                // title: 'Сообщить об ошибке',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadBazisClub',
            bazisClubItems: 'loadBazisClubItems',
            counter: 'loadBazisCategoryCounter',
        }),
        methods: {
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/bazis-club/bazis-club-category.scss';
    @import '@/styles/respond/bazis-club/bazis-club-category-respond.scss';
</style>